import { createContext } from 'react';

import { PaymentsSDK } from '../types';

const PaymentsContext = createContext<{
  paymentsSDK: PaymentsSDK;
}>({
  paymentsSDK: null,
});

export default PaymentsContext;
